<template>
  <div id="app">
    <router-view v-if="showHeader" name="header" :key="$route.fullPath" />
    <div class="wrapper">
      <router-view :key="$route.fullPath" :lojaEncontrada="lojaEncontrada" />
    </div>
    <router-view v-if="showFooter" name="footer" />
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import storage from './services/storage';

// eslint-disable-next-line no-unused-vars
import ws from './services/ws';

import goToHome from './services/goToHome';
import service from './services';

export default {
  metaInfo() {
    const title = this.nomeLoja;

    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: title,
        },
      ],
    };
  },
  watch: {
    $route: {
      handler: function(search) {
        if (search) this.retornaLinkLoja();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      showFooter: true,
      showHeader: true,
      iconeCarregando: service.getEnvIconeCarregando(),
      carregando: false,
      bgColor: '#ffffff',
      tema: {
        corDeTextoDestaque: '#00a24d',
        corTextoTituloPaginas: '#00a24d',
        corDeFundo: '#e3e3e3',
        corDoBackGroundTopo: '#ffffff',
        corTextoPadrao: '#545454',
        corDeFundoBoxesHover: '#ffffff',
        corDeFundoDosBoxes: '#ffffff',
        corDeTextoTituloBoxes: '#424242',
        corDeTextoTituloBoxesHover: '#333333',
        corDeTextoDoValorOld: '#5a5858',
        corDeTextoDoValor: '#00a24d',
        corDeTextoDoValorHover: '#00a24d',
        corDoBackGroundMenuMobile: '#fcfcfc',
        corDoBackGroundMenuMobile2: '#d2d0d0',
        corDosLinksMenu: '#0d0c0c',
        corDosLinksMenuOver: '#00a24d',
        corDeFundoDoRodape: '#fafafa',
        corDeTextoDoRodape: '#5a5858',
        corDosLinksDoRodape: '#5a5858',
        corDosLinksDoRodapeHover: '#00a24d',
      },
      lojaEncontrada: false,
      linkLoja: this.$route.params,
      nomeLoja: null,
    };
  },
  methods: {
    retornaLinkLoja() {
      let linkLoja = this.$route.params.loja
        ? this.$route.params.loja
        : storage.lerStorage('linkLoja');
      const subdomain = window.location.host.split('.')[1]
        ? window.location.host.split('.')[0]
        : false;
      if (subdomain && subdomain != 'achadosepromocoes') {
        linkLoja = subdomain;
      }
      if (window.location.host.indexOf('clubecerto') >= 0) {
        linkLoja = 'clubecerto';
      }
      if (this.$route.query.showFooter == 'false') {
        this.showFooter = false;
        storage.escreveStorage('showFooter', 'false');
      }

      if (this.$route.query.showHeader == 'false') {
        this.showHeader = false;
        storage.escreveStorage('showHeader', 'false');
      }

      if (this.$route.query.color && this.$route.query.color != 'undefined') {
        console.log('color', this.$route.query.color);
        storage.escreveStorage('corPadrao', '#' + this.$route.query.color);
        const cor = '#' + this.$route.query.color;
        this.tema.corDeTextoDestaque = cor;
        this.tema.corTextoTituloPaginas = cor;
        this.tema.corDeTextoDoValor = cor;
        this.tema.corDeTextoDoValorHover = cor;
        this.tema.corDosLinksMenuOver = cor;
        this.tema.corDosLinksDoRodapeHover = cor;
      } else {
        storage.escreveStorage('corPadrao', '#00a24d');
      }

      if (this.$route.query.logo && this.$route.query.logo != 'undefined') {
        storage.escreveStorage('logo', this.$route.query.logo);
      } else {
        storage.escreveStorage(
          'logo',
          'https://novositecbc.s3.us-east-2.amazonaws.com/assets/logo-clube-certo.webp',
        );
      }

      return linkLoja;
    },
    async buscaTemaEmpresa() {
      this.carregando = true;
      this.linkLoja = await this.retornaLinkLoja();
      if (this.linkLoja)
        service
          .getAll(
            'Empresas',
            {},
            'GetTema?idEmpresa=null&linkLoja=' + this.linkLoja,
          )
          .then(res => {
            this.carregando = false;
            this.nomeLoja = res.data[0].nomeEmpresa;
            let auxTema = {};

            if (res.data[0] && res.data[0].temaCor) {
              auxTema = JSON.parse(res.data[0].temaCor);
            }

            if (storage.lerStorage('corPadrao')) {
              let corPadrao = storage.lerStorage('corPadrao') || '';
              corPadrao =
                corPadrao.indexOf('#') >= 0 ? corPadrao : '#' + corPadrao;
              auxTema.corTextoTituloPaginas = corPadrao;
              auxTema.corDeTextoDoValor = corPadrao;
              auxTema.corDeTextoDoValorHover = corPadrao;
              auxTema.corDeTextoDestaque = corPadrao;
            }

            if (!storage.lerStorage('logo')) {
              storage.escreveStorage('logo', res.data[0].logo);
            }

            storage.escreveStorage('idEmpresa', res.data[0].idEmpresa);
            storage.escreveStorage('tema', JSON.stringify(auxTema));

            storage.escreveStorage('nomeEmpresa', res.data[0].nomeEmpresa);
            storage.escreveStorage('grupoWhats', res.data[0].grupoWhats);
            storage.escreveStorage('linkLoja', this.linkLoja);
            storage.escreveStorage(
              'redesSociais',
              JSON.stringify({
                instagram: res.data[0].instagram,
                telegram: res.data[0].telegram,
                twitter: res.data[0].twitter,
                threads: res.data[0].threads,
                tiktok: res.data[0].tiktok,
              }),
            );
            const favicon = document.getElementById('favicon');
            if (favicon) favicon.href = res.data[0].logo;

            //document.title = res.data[0].nomeEmpresa;
            this.tema = auxTema;
            this.lojaEncontrada = true;
            this.$forceUpdate();
          })
          .catch(error => {
            this.exibeErro = true;
            this.msgErro = 'Não foi possível Buscar Tema! \n\n ' + error;
            this.carregando = false;
          });
    },
    getTema() {
      // this.buscaTemaEmpresa();
    },
  },
  created() {
    this.retornaLinkLoja();
    //this.getTema();
    storage.subscribe(goToHome.goToHomeWhenLogoff);
    if (this.$route.query) {
      if (this.$route.query.fbclid)
        storage.escreveStorage('fbclid', this.$route.query.fbclid);
    }
  },
};
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/eliyantosarage/font-awesome-pro@main/fontawesome-pro-6.5.1-web/css/all.min.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css');

#app {
  background-color: v-bind(tema.corDeFundo);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: v-bind(tema.corTextoPadrao) !important;
}

#app a {
  color: v-bind(tema.corTextoPadrao);
}

#whitelabel {
  min-height: 70vh;
  padding: 1rem;
  position: relative;
  /**/
}

.banner-desk {
  margin-top: v-bind(showHeader? '100px': '0px');
}

.box-interno {
  min-height: 56vh;
}

.conteudoGenerico {
  min-height: 100vh;
  padding: 1rem;
  position: relative;
}

.card {
  color: #000;
}

.btn {
  border-radius: 0 !important;
  background-color: v-bind(tema.corDeTextoDestaque) !important;
  color: #fff !important;
}

.btn i {
  font-size: 16px;
}
.modal-content,
.modal-content a {
  color: #000 !important;
}

body:not(.logged-page) .form-check .form-check-sign::before,
body:not(.logged-page) .form-check .form-check-sign::after {
  border: 1px solid v-bind(tema.degradeCor1) !important;
}

.logged-page .form-check .form-check-sign::before,
.logged-page .form-check .form-check-sign::after {
  border: 1px solid v-bind(tema.corDeTextoPaginasInternas) !important;
}

.tituloPagina {
  color: v-bind(tema.corTextoTituloPaginas);
}

.button-outline {
  font-weight: bold;
  color: v-bind(tema.degradeCor1) !important;
  border: 2px solid v-bind(tema.degradeCor1) !important;
  background-color: transparent !important;
  padding: 11px 23px;
  border: none;
}

.button-outline:hover {
  border: 2px solid v-bind(tema.degradeCor1Hover) !important;
  color: v-bind(tema.degradeCor1Hover) !important;
}

/*DEGRADES*/
.btn-degrade,
.categoria-selecionada {
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1),
    v-bind(tema.degradeCor2)
  ) !important;
  color: v-bind(tema.corTextoBotao) !important;
}

.dropdown .btn-primary {
  background-color: v-bind(tema.corFundoBotaoFormularios);
  color: v-bind(tema.corTextoBotaoFormularios) !important;
}

.btn-degrade:hover {
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1Hover),
    v-bind(tema.degradeCor2Hover)
  ) !important;
  color: v-bind(tema.corTextoBotaoHover) !important;
}

.btn-brilho,
.card-selecionado {
  -webkit-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1) !important;
  -moz-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1) !important;
  box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1) !important;
}

.bootstrap-switch {
  background-color: rgba(255, 255, 255, 0.8) !important;
  -webkit-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1);
  -moz-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1);
  box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1);
}
.bootstrap-switch .bootstrap-switch-label {
  background-color: v-bind(tema.degradeCor1);
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1),
    v-bind(tema.degradeCor2)
  ) !important;
}
.bootstrap-switch .bootstrap-switch-container {
}

/*MENU E MENU MOBILE*/
.sidebar-collapse .navbar-collapse:before {
  background: v-bind(
    tema.corDoBackGroundMenuMobile
  ); /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* Standard syntax (must be last) */
}

.linkMenu,
.linkDropMenu a {
  color: v-bind(tema.corDosLinksMenu) !important;
}

.linkMenu:hover,
.linkDropMenu a:hover {
  color: v-bind(tema.corDosLinksMenuOver) !important;
}

.linkDropMenu .show a,
.linkDropMenu .show a:hover {
  color: v-bind(tema.corTextoPadrao) !important;
}

.nav-open .navbar .show a,
.nav-open .navbar .linkDropMenu .show a:hover {
  color: v-bind(tema.corDosLinksMenu) !important;
}

.sidebar-collapse .navbar .navbar-toggler-bar {
  background: v-bind(tema.corDosLinksMenu) !important;
}

.navbar-toggler:hover .navbar-toggler-bar {
  background: v-bind(tema.corDosLinksMenuOver) !important;
}

.menu-navbar,
.page-header {
  background-color: v-bind(tema.corDoBackGroundTopo) !important;
  color: v-bind(tema.corTextoTituloPaginas) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu {
  background-color: v-bind(tema.corDeFundoMenuDropDown) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu:before {
  color: v-bind(tema.corDeFundoMenuDropDown) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu a {
  color: v-bind(tema.corDeTextoMenuDropDown) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu a:hover {
  color: v-bind(tema.corDeTextoMenuDropDownHover) !important;
}

/*RODAPE*/

.footer {
  background-color: v-bind(tema.corDeFundoDoRodape) !important;
  color: v-bind(tema.corDeTextoDoRodape) !important;
}

.footer .nav-link {
  color: v-bind(tema.corDosLinksDoRodape) !important;
}

.footer .nav-link:hover {
  color: v-bind(tema.corDosLinksDoRodapeHover) !important;
}

/*BANNERS*/
.banner-desk {
  background-color: v-bind(tema.corDeFundoDoBoxBanner) !important;
  color: v-bind(tema.corTextoBoxBanner) !important;
}

/*FILTRO */
.filtro {
  background-color: v-bind(tema.corDeFundoFiltro) !important;
  color: v-bind(tema.corDeTextoItensFiltro) !important;
}

.filtro .resetFilter {
  color: v-bind(tema.corDeLinkResetFiltros) !important;
}

.filtro .categoria {
  background-color: v-bind(tema.corDeFundoItensFiltro) !important;
  color: v-bind(tema.corDeTextoItensFiltro) !important;
  border: 1px solid v-bind(tema.corDeBordaItensFiltro) !important;
}

.filtro .categoria-selecionada {
  color: v-bind(tema.corDeTextoItensFiltroSelecionado) !important;
}

/*BOX HOME*/
.lista-de-caixas .box {
  background-color: v-bind(tema.corDeFundoDosBoxes) !important;
}

.box-destaque {
  border: 2px solid v-bind(tema.corTextoTituloPaginas) !important;
}

.lista-de-caixas .box:hover {
  background-color: v-bind(tema.corDeFundoBoxesHover) !important;
}

.lista-de-caixas .box .nomeCaixa {
  color: v-bind(tema.corDeTextoTituloBoxes) !important;
}

.lista-de-caixas .box:hover .nomeCaixa {
  color: v-bind(tema.corDeTextoTituloBoxesHover) !important;
}

.lista-de-caixas .box .badge-valor,
.modal-content .badge-valor {
  background-color: v-bind(tema.corDeFundoDoValor) !important;
  color: v-bind(tema.corDeTextoDoValor) !important;
}

.lista-de-caixas .box:hover .btn:not(.btn-desabilitado) {
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1Hover),
    v-bind(tema.degradeCor2Hover)
  ) !important;
  color: v-bind(tema.corTextoBotaoHover) !important;
}

.lista-de-caixas .box:hover .badge-valor {
  background-color: v-bind(tema.corDeFundoDoValorHover) !important;
  color: v-bind(tema.corDeTextoDoValorHover) !important;
}

.lista-de-caixas .box .btn-desabilitado {
  background-color: transparent !important;
  border: 1px solid v-bind(tema.corBordaBotaoDesabilitado) !important;
  color: v-bind(tema.corTextoBotaoDesabilitado) !important;
}

/*BOX DETALHES*/
.detalheProduto .container {
  background-color: v-bind(tema.corDeFundoDosBoxes) !important;
}
.detalheProduto .badge-valor {
  background-color: v-bind(tema.corDeFundoDoValor) !important;
  color: v-bind(tema.corDeTextoDoValor) !important;
}

.detalheProduto .nomeCaixa {
  color: v-bind(tema.corDeTextoTituloBoxes) !important;
}

/*PAGINAS Genericas*/
.box-interno .page-header {
  background-color: v-bind(tema.corDeFundoTituloPaginasGenericas) !important;
}

.box-interno .page-header .title {
  text-align: center;
  color: v-bind(tema.corDeTextoTituloPaginasGenericas) !important;
}

/*BOTOES*/
.btn-primario-formulario {
  background-color: v-bind(tema.corDeFundoBotaoPrimarioFormularios) !important;
  color: v-bind(tema.corDeTextoBotaoPrimarioFormularios) !important;
}
.btn-primario-formulario:hover {
  background-color: v-bind(
    tema.corDeFundoBotaoPrimarioFormulariosHover
  ) !important;
  color: v-bind(tema.corDeTextoBotaoPrimarioFormulariosHover) !important;
}

/*FAQ*/
.perguntas .card-item {
  border-left: 3px solid v-bind(tema.corDeBordaPerguntas) !important;
  background-color: v-bind(tema.corDeFundoPergunta) !important;
}
.perguntas .card-item .indice {
  background-color: v-bind(tema.corDeFundoNumeroPergunta) !important;
  color: v-bind(tema.corDeTextoNumeroPergunta) !important ;
}
.perguntas .card-item .resposta {
  background-color: v-bind(tema.corDeFundoResposta) !important;
  color: v-bind(tema.corDeTextoResposta) !important ;
}
.perguntas .card-item a {
  color: v-bind(tema.corDeTextoPergunta) !important ;
}

.perguntas .card-item i {
  color: v-bind(tema.corDaSeta) !important ;
}
</style>
<style lang="scss">
.resetFilter {
  font-size: 12px;
  font-weight: 900 !important;
  cursor: pointer;
}
.labelAbrirCaixa {
  vertical-align: middle;
}
.categoria {
  cursor: pointer;
  font-size: 14px;
}

.categoria-selecionada {
  font-weight: bold;
}
.tab-content.tab-content-padding {
  padding: 20px;
}

.mobile-margin {
  //margin-top: 100px;
}

.lista-de-caixas {
  display: flex;
  flex-direction: column;
  gap: 3rem;

  // grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  grid-gap: 0.6rem;
  padding: 0.6rem 0;

  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(318px, 1fr));
  grid-gap: 0.5rem;
  grid-auto-flow: dense;
}

.iconDestaquesCaixa {
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-gap: 0.5rem;
  grid-auto-flow: dense;
}
@media (min-width: 767.98px) {
  .lista-de-caixas {
    grid-template-columns: repeat(auto-fill, minmax(318px, 1fr));
    grid-gap: 0.6rem;
    padding: 0.6rem 0;
  }
  .iconDestaquesCaixa {
    // grid-template-columns: repeat(auto-fill, minmax(213px, 1fr));
    grid-gap: 0.6rem;
    padding: 0.6rem 0;
  }
}
</style>
